import React, { useState } from 'react';
import { func, object, string, node, oneOf } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { shouldDisplayMigrationPopup } from '@fiverr-private/business_blocks';
import { Button } from '@fiverr-private/fit';
import { isLoggedInUser } from '../../../utils/isLoggedInUser';
import { triggerFibMigrationPopup } from '../../../utils/fibMigrationPopup';
import { FirstMessagePopup } from '../FirstMessagePopup';
import { onGuestClick, redirectToInboxConversation } from '../../../utils/contactSeller';
import { useOpenUserActivationModalWrapper } from '../UserActivationModalWrapper/utils';
import { SUPPORTED_ACTIONS } from '../UserActivationModalWrapper/constants';
import UserActivationModalWrapper from '../UserActivationModalWrapper';
import { CONTACT_TRIGGER } from './constants';

const ContactTrigger = (
    { onClick, className, children, buttonColor },
    { pathfinderWrapper, general, biEvents, currentUser }
) => {
    const { shouldRenderAndOpenUserActivationModal } = useOpenUserActivationModalWrapper();
    const [renderAndOpenUserActivationModal, setRenderAndOpenUserActivationModal] = useState(false);
    const [renderFirstMessagePopup, setRenderFirstMessagePopup] = useState(false);

    const handleClick = async() => {
        onClick();

        if (!isLoggedInUser()) {
            return onGuestClick({ biEvents, pathfinderWrapper });
        }

        if (await shouldRenderAndOpenUserActivationModal(currentUser)) {
            setRenderAndOpenUserActivationModal(true);
            return;
        }

        if (shouldDisplayMigrationPopup()){
            triggerFibMigrationPopup(CONTACT_TRIGGER, sendMessage);
            return;
        }

        sendMessage();
    };

    const sendMessage = () => {
        const { isMobile } = getContext();

        isMobile ? redirectToInboxConversation(pathfinderWrapper) : setRenderFirstMessagePopup(true);
    };

    const getButtonColor = () => {
        if (buttonColor) {
            return buttonColor;
        }
        return general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREY;
    };

    const buttonProps = {
        className,
        color: getButtonColor(),
        fill: Button.FILLS.GHOST,
        onClick: handleClick
    };

    if (general.isOnVacation){
        return null;
    }

    return (
        <>
            <Button {...buttonProps}>
                {children}
            </Button>

            <FirstMessagePopup shouldRender={renderFirstMessagePopup}
                onClose={() => setRenderFirstMessagePopup(false)}/>

            <UserActivationModalWrapper renderAndOpen={renderAndOpenUserActivationModal}
                onClose={() => setRenderAndOpenUserActivationModal(false)}
                action={SUPPORTED_ACTIONS.CONTACT_SELLER}/>
        </>
    );
};

ContactTrigger.propTypes = {
    onClick: func.isRequired,
    className: string,
    children: node,
    buttonColor: oneOf(Object.values(Button.COLORS))
};

ContactTrigger.contextTypes = {
    pathfinderWrapper: object,
    general: object,
    biEvents: object,
    currentUser: object
};

export default ContactTrigger;
